<template>
    <Modal :allow-close="visible" :hide-actions="true" rounded-size="rounded-3xl" max-width="sm:max-w-2xl" @modal:close="handleClose()">
        <template #body>
                <h1  class="mt-2 text-[24px] text-center font-semibold mb-8 text-won-blue">Are you sure?</h1>
                
                <p class="mt-4 text-won-blue font-[16px]" >Subscribe now for <b>UNLIMITED</b> tools access & early entry to <b>AutoApplyAI</b>. Lock in this rate—even if prices rise, yours stays the same for as long as you’re subscribed.</p>
        
                <p class="mt-4 text-won-blue font-[16px]" v-if="getUser().generations > 10">Your 25% discount is a 1 time offer and cannot be redeemed at a later time.</p>
            
        
                 <div class="my-6 flex justify-end items-center">
                    <p class="h-9 won-green-background-color font-medium text-sm px-2.5 rounded text-white transition font-noto hover:opacity-90 flex items-center justify-center mr-4 cursor-pointer justify-center font-medium font-[Roboto]" @click="() => $emit('goback')">Go back</p>
                    <button @click="() => $emit('decline:offer')" class="w-48  py-2 rounded border border-[#CE2020] text-[#CE2020]  bg-white">
                        Decline Offer
                    </button>
                </div>
        </template>
    </Modal>
</template>

<script setup>
import Modal from "../../components/modal";
import { useNotifications } from '../../store/notifications.store'
import {ref} from 'vue'
import {setAuthState} from "../../composables/auth";

const submitting = ref(false)
const emit = defineEmits(['goback', 'decline:offer'])
const notificationStore =  useNotifications()
const {getUser} =  setAuthState()

const props = defineProps({
    visible: {
        type: Boolean,
        default: false,
    },
})


const handleClose = async () => {
    emit("terms-condition:accepted");
}


</script>
